import { styled, Typography } from '@ori-ui/mui';

import { maxTextWidth } from '../../constants';

export const Root = styled(Typography)(() => ({
  display: 'block',
  maxWidth: maxTextWidth,
}));
